import { Model } from "@tailflow/laravel-orion/lib/model";

export class Note extends Model<{
  name: string;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "notes";
  }
}
